// extracted by mini-css-extract-plugin
export default {"wrapper":"CenterStageMemberIcon_wrapper__32iAJ"};